import * as d3 from "d3";

export const periods = [
  { hours: 24, description: "1 Day", period: "oneDay", alt: "Day" },
  { hours: 24 * 2, description: "2 Days", period: "twoDays", alt: "TwoDays" },
  {
    hours: 24 * 3,
    description: "3 Days",
    period: "threeDays",
    alt: "ThreeDays",
  },
  { hours: 24 * 7, description: "1 Week", period: "oneWeek", alt: "Week" },
  { hours: 24 * 30, description: "1 Month", period: "oneMonth", alt: "Month" },
  {
    hours: 24 * 90,
    description: "3 Months",
    period: "threeMonths",
    alt: "ThreeMonths",
  },
];

const periodEntryTwoWeeks = {
  hours: 24 * 7 * 2,
  description: "2 Weeks",
  period: "twoWeeks",
  alt: "TwoWeeks",
};

export const periodsTwoWeeks = periods.toSpliced(4, 0, periodEntryTwoWeeks);

export const periodAsHours = Object.fromEntries(
  periodsTwoWeeks.map(({ period, hours }) => [period, hours]),
);
export const hoursAsPeriod = Object.fromEntries(
  periodsTwoWeeks.map(({ period, hours }) => [hours, period]),
);

export const hoursScopeChoices = periods.map(({ description, hours }) => ({
  value: hours,
  label: description,
}));

export const hoursScopeChoicesTwoWeeks = periodsTwoWeeks.map(
  ({ description, hours }) => ({ value: hours, label: description }),
);

export const periodChoices = periods.map(({ description, period }) => ({
  value: period,
  label: description,
}));

const noMoreThanAMonth = ({ hours }) => hours <= periodAsHours["oneMonth"];

export const limitedPeriodChoices = periods
  .filter(noMoreThanAMonth)
  .map(({ description, period }) => ({ value: period, label: description }));

export const categoryChoices = [
  { value: 5, label: "5 Cats." },
  { value: 10, label: "10 Cats." },
  { value: 15, label: "15 Cats." },
  { value: 20, label: "20 Cats." },
  { value: 30, label: "30 Cats." },
];

// Seconds between the reloads of the views refreshed periodically.
export const RELOAD_PERIOD = 3;

export const PERIOD_TO_HOURS = {
  ...periodAsHours,
  // Kept Week, Month, etc for compatibility reasons
  ...Object.fromEntries(periodsTwoWeeks.map(({ alt, hours }) => [alt, hours])),
};

export const LINES_BY_HOUR = 12; // Number of 5-minute intervals in an hour;

export const PERIOD_TO_LINES = Object.fromEntries(
  Object.entries(PERIOD_TO_HOURS).map(([key, hours]) => [
    key,
    hours * LINES_BY_HOUR,
  ]),
);

export const HOURS_TO_PERIOD = Object.fromEntries(
  periodsTwoWeeks.map(({ alt, hours }) => [hours, alt]),
);
export const altPeriodScopeChoices1MonthOrLess = periods
  .filter(noMoreThanAMonth)
  .map(({ description, alt }) => ({ value: alt, label: description }));

export const altPeriodScopeChoices = periods.map(({ description, alt }) => ({
  value: alt,
  label: description,
}));

export const TIMEWINDOW_MAX_MAP = {
  2: 1000 * 60 * 2,
  200: 1000 * 60 * 2,
  5: 1000 * 60 * 5,
  500: 1000 * 60 * 5,
  10: 1000 * 60 * 10,
  1000: 1000 * 60 * 10,
};

export const formats = {
  noDecimals: d3.format(".0f"),
  oneDecimal: d3.format(".1f"),
  twoDecimals: d3.format(".2f"),
  threeDecimals: d3.format(".3f"),
  fourDecimals: d3.format(".4f"),
};

export const metricChoices = [
  { value: "all", label: "All" },
  { value: "Rtt-80%-Dn-Ms", label: "P80-80th percentile" },
  { value: "Rtt-Med-Dn-Ms", label: "P50-Median" },
  { value: "Rtt-Min-Dn-Ms", label: "Mean-Min" },
];
